<template>
  <v-dialog 
    v-model="dialog"
    persistent
    hide-overlay
    class="ai-dialog"
    max-width="390"
    @click:outside="onClickOutside"
    @keydown="onKeydown">
    <v-card class="ai-dialog">
      <v-card-title>
        <h3 class="mb-0">Hey Sammi</h3>
        <v-spacer/>
        <v-btn
          color="accent"
          icon
          @click="closeDialog"
        >
          <v-icon size="24">mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col>
              <dialog-input
                label="Your question"
                name="question"
                :value="questionValue"
                :textarea="true"
                :auto-grow="true"
                :readonly="false"
                :textareaExpandable="false"
                @input="onInput" />
            </v-col>
          </v-row> 
          <v-row class="text-right">
            <v-col>
              <v-btn 
                color="accent" 
                rounded 
                elevation="0" 
                @click="onAsk" 
                :disabled="loading"
                :loading="loading">
                Hey Sammi
              </v-btn>
            </v-col>
          </v-row>
          <v-row v-if="answer">
            <v-col>
              <dialog-input
                label="Sammi answer"
                name="answer"
                :value="answerValue"
                :textarea="true"
                :auto-grow="true"
                :readonly="false"
                :textareaExpandable="false"
                @input="onInput" />
            </v-col>
          </v-row>
          <v-row class="text-right" v-if="answer">
            <v-col>
              <v-btn rounded elevation="0" class="mr-2" @click="closeDialog">Cancel</v-btn>
              <v-btn rounded elevation="0" color="accent" @click="onSend">Send</v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import DialogInput from '@/components/forms/DialogInput.vue'

export default {
  name: 'AskAiDialog',
  components: {
    DialogInput
  },
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    question: {
      type: [String, Number],
      default: ''
    },
    answer: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      dialog: false,
      questionValue: '',
      answerValue: '',
    }
  },
  computed: {
    
  },
  watch: {
    showDialog (val) {
      if (val) {
        this.dialog = val
        this.questionValue = this.question
        this.answerValue = this.answer
      } else {
        this.closeDialog()
      }
    },
    question(newVal, oldVal) {
      if (newVal || oldVal!=newVal) this.questionValue = newVal
    },
    answer(newVal, oldVal) {
      if (newVal || oldVal!=newVal) this.answerValue = newVal
    }
  },
  methods: {
    closeDialog () {
      this.$emit('close-dialog')
      this.dialog = false
    },
    onClickOutside() {
      this.closeDialog()
    },
    onKeydown(key) {
      if (key.code === "Escape" && key.isTrusted) this.closeDialog()
    },
    onInput(val) {
      if (val.name == 'answer') this.answerValue = val.value
      if (val.name == 'question') this.questionValue = val.value
    },
    onAsk() {
      this.$emit('askQuestion', this.questionValue)
    },
    onSend() {
      this.$emit('confirmAnswer', this.answerValue)
      this.$emit('close-dialog')
    }
  }
}
</script>

<style lang="scss" >
@import "@/styles/variables.scss";

.ai-dialog {
  .v-textarea {
    background-color:$bh-gray--6 !important;
    .v-input__slot {
      background-color: $bh-gray--6 !important; 
    }
    textarea {
      background-color: $bh-gray--6;
      overflow-y: auto;
      max-height: 300px;
      resize: none;
      min-height: 50px;
    }
  }
}

</style>
